import React, { useState, useEffect } from 'react';

export interface ConnectionStatusProps {
  isDbConnected: boolean;
  isSynced: boolean;
  timeOffset: number;
}

/**
 * Indicadores de conexão com o banco e relógio sincronizado via rede.
 * @param props - Status de DB e offset de horário
 */
export const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  isDbConnected,
  isSynced,
  timeOffset,
}) => {
  const [currentTime, setCurrentTime] = useState(new Date(Date.now() + timeOffset));

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date(Date.now() + timeOffset));
    }, 1000);
    return () => clearInterval(timer);
  }, [timeOffset]);

  const formattedTime = currentTime.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  const formattedDate = currentTime.toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  });

  return (
    <>
      <div
        title={isDbConnected ? 'O Sistema esta conectado ao banco de dados' : 'Sistema desconectado do banco de dados'}
        className={`flex items-center justify-center size-7 rounded-full border shadow-inner transition-all hover:scale-105 cursor-help ${isDbConnected ? 'bg-status-green/10 border-status-green/30 text-status-green' : 'bg-status-red/10 border-status-red/30 text-status-red'}`}
        aria-label={isDbConnected ? 'Banco de dados conectado' : 'Banco de dados desconectado'}
      >
        <span className="material-symbols-outlined !text-[14px] drop-shadow-sm">dns</span>
      </div>

      <div
        title={`${formattedDate} | ${isSynced ? 'Horário Validado via Rede (API)' : 'Usando Horário do Dispositivo'}`}
        className="flex items-center gap-1.5 px-3 py-1 bg-slate-50 rounded-lg border border-slate-100 shadow-inner group cursor-help transition-all hover:bg-slate-100/80"
      >
        <div className="flex flex-col items-center">
          <span
            className={`material-symbols-outlined !text-[12px] transition-all ${isSynced ? 'text-status-green group-hover:animate-pulse' : 'text-slate-300'}`}
          >
            {isSynced ? 'verified' : 'sync'}
          </span>
          {isSynced && (
            <span className="text-[5px] font-black uppercase text-status-green -mt-0.5 leading-none">Net</span>
          )}
        </div>
        <span
          className={`text-[10px] font-bold font-mono tracking-wider tabular-nums transition-colors ${!isSynced ? 'text-slate-300' : 'text-slate-600'}`}
        >
          {isSynced ? formattedTime : 'Sincronizando...'}
        </span>
      </div>
    </>
  );
};
